<span class="cursor-pointer text-[#999999] flex items-center gap-2" id="settings-menu-selector">
    <sh-icon icon="settings" size="s" class="text-[#999999]"></sh-icon>
</span>
<sh-popover target="settings-menu-selector" position="bottom">
    <sh-menu-item
        [label]="'common.header.user-settings' | translate"
        [toggle]="false"
        (click)="openLink('user-settings')"
    ></sh-menu-item>
    @if (canManageOutOfOffice()) {
        <sh-menu-item
            [label]="'common.header.manage-out-of-office' | translate"
            [toggle]="false"
            (click)="openLink('manage-ooo')"
        ></sh-menu-item>
    }
    @if (canSeeOutOfOfficeCalendar()) {
        <sh-menu-item
            [label]="'common.header.out-of-office-calendar' | translate"
            [toggle]="false"
            (click)="openLink('calendar-view')"
        ></sh-menu-item>
    }
    <sh-divider></sh-divider>
    <sh-menu-item
        [label]="'common.general.download-logs' | translate"
        [toggle]="false"
        (click)="downloadLogs()"
    ></sh-menu-item>
</sh-popover>
